module.exports = __webpack_public_path__ + "static/media/SavedAnEvent.41ae95c4.png";